<template>
  <div class="stages" id="stages" v-scroll="onScroll">
    <StageIcons :stages="stages" :startHours="startHours" :endHours="endHours" :openText="openText" :bodyColor="bodyColor" :scrollLeft="scrollLeft"></StageIcons>
    <el-container class="stage" v-scroll="onScroll" v-for="stage in stages" :key="stage" :style="{ height: styleContainerHeight + 'px' }" v-if="stage.preview">
      <el-main :style="{backgroundColor: stage.background_color, height: styleContainerHeight + 'px'}">
        <div class="artists">
          <el-card class="artist" v-for="artist in stage.artists" :key="artist.name" :style="[artistDataToStyle(artist.performing_time), {border: '1px solid ' + stage.background_color, backgroundColor: ( artist.artist_color ? artist.artist_color : stage.artist_color)}]" @click.native="previewArtistDialog(artist.artist_id)" v-if="artistValidation(artist)">
            <div class="canceled" v-if="artist.canceled">
              <h3 class="start-time" :style="{fontSize: artist.fontSize + 'px'}">{{artist.preview_time}}</h3>
              <h3 class="artist_name" :style="{fontSize: artist.fontSize + 'px'}">{{artist.name}}</h3>
            </div>
            <div v-else>
              <h3 class="start-time" :style="{fontSize: artist.fontSize + 'px'}">{{artist.preview_time}}</h3>
              <h3 class="artist_name" :style="{fontSize: artist.fontSize + 'px'}">{{artist.name}}</h3>
            </div>
          </el-card>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import StageIcons from './StageIcons'
export default {
  name: 'Stage',
  props: {
    headerHeight: {
      default: 150 + 'px'
    },
    stages: {
      type: Array,
      required: true
    },
    startHours: '',
    endHours: '',
    openText: '',
    bodyColor: '',
    scrollLeft: ''
  },
  watch: {
    startHours: function (val) {
      this.startHours = val
    },
    endHours: function (val) {
      this.endHours = val
      this.setHeight()
    },
    scrollLeft: function () {
      this.updateScroll()
    }
  },
  data () {
    return {
      artistInfo: '',
      styleContainerHeight: 0, // el-header + el-mainの高さの合計値
      styleMainHeight: 0, // el-mainの高さ(実質の開催時間 * 144の数値)
      styleHeaderHeight: 150,
      fullScreenLoading: false,
      headerSize: 0,
      commonInfoWrapWidth: 160
    }
  },
  components: {
    StageIcons
  },
  beforeMount () {
    this.setHeight()
    // ヘッダーの高さを取得
    var element = document.getElementById('gHeader')
    var style = (element.currentStyle || document.defaultView.getComputedStyle(element, '')).height
    this.headerSize = parseInt(style.replace('px', ''))
  },
  methods: {
    setHeight () {
      // this.styleHeaderHeightを追加することで、this.styleContainerHeightはheaderとel-mainの高さを含んだものになる
      const performanceTime = Math.abs(this.endHours - this.startHours) // マイナスになる可能性があるので、絶対値として処理
      this.styleMainHeight = (performanceTime * 144) // 144px = 12px/分 * (60分/5分 = 12) = 1時間| 5分単位でタイムテーブルを作成している。144pxに実施時間を掛けた内容
      this.styleContainerHeight = (performanceTime * 144) + this.styleHeaderHeight // 144px = 12px/分 * (60分/5分 = 12) = 1時間| 5分単位でタイムテーブルを作成している。el-header + el-mainの合計値
    },
    timeToPositionY (time) {
      const {startHours, endHours} = this
      const [hours, minutes] = time.split(':')
      const hoursFromStart = parseInt(hours) - this.startHours
      const minutesFromStart = hoursFromStart * 60 + parseInt(minutes)
      return minutesFromStart / ((endHours - startHours) * 60)
    },
    artistDataToStyle (artistData) {
      const {start_time: startTime, end_time: endTime} = artistData
      const top = this.timeToPositionY(startTime) * this.styleMainHeight
      // const top = this.timeToPositionY(startTime) * 1872
      const height = this.timeToPositionY(endTime) * this.styleMainHeight - top
      // const height = this.timeToPositionY(endTime) * 1872 - top
      return {
        top: top + 'px',
        height: height + 'px'
      }
    },
    previewArtistDialog (artistId) {
      this.$parent.$parent.artistId = artistId
      this.$parent.$parent.dialogTableVisible = true
    },
    artistValidation (artist) {
      // アーティスト名のバリデーション
      if (!artist.name) {
        return false
      }

      // 演奏時間のバリデーション
      if (!artist.performing_time || !artist.performing_time.start_time || !artist.performing_time.end_time) {
        return false
      }

      // enableフラグの判定 & バリデーション
      if (!artist.enable) {
        return false
      }
      return true
    },
    onScroll: function (e, position) {
      this.scrollLeft = position.scrollLeft
    },
    updateScroll () {
      document.getElementById('stages').scrollTo(this.scrollLeft, 0)
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/components/parts/Stage";
</style>



// WEBPACK FOOTER //
// src/components/parts/Stage.vue